module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDCAMAAABdlVDoAAAAS1BMVEXXFBrTFh1sL1D02tz53d6DkK4VRH02PGs3PGt0LEx1LEuyHSyzHCzTFRvUFRzXFBoRRX6Ior8WSYE+aJZjX4TT3efriYz6+/z///80Wqe8AAAABnRSTlPU1en4+PtAtsV6AAAA6ElEQVR42rXPuVVDMQAAQQH2BwxG4rCh/0oJN1Yw28C8HeenE2+s79ufbqz19fnrkdUMRJqBSDMQaQYizUikGYk0Q5FmJNIMRZqRSDMUaUYizVCkGYk0Q5FmJNIMRZqRSDMUaUYizVCkGYk0Q5FmJNIMRZqRSDMUaUYizVCkGYfUz327XeR4vc7tNpHnt1kAaQMhbTCkDYe0wZA2HNIGQ9pwSBsMacMhbTCkDYe0wZA2HNIGRo5LGwp5eZ8TIW18TIe0wZA2HNIGQ9pwSBsMacMhbTCkDYe04ZA2INIGRNqASBsQeXwYvH/aEdiCmtytLgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cz.png
// module id = AFAp
// module chunks = 0